







































































































import {Component, Mixins, Ref} from 'vue-property-decorator';
import RestockContent from '@/components/product/restock/RestockContent.vue';
import PageContentBottom from '@/components/common/PageContentBottom.vue';
import PageTitle from '@/components/common/PageTitle.vue';
import PageFormBtn from '@/components/board/common/PageFormBtn.vue';
import PageFormSelect from '@/components/board/common/PageFormSelect.vue';
import PageDateRangePicker from '@/components/board/common/PageDateRangePicker.vue';
import PageDateFilterBtns from '@/components/board/common/PageDateFilterBtns.vue';
import PageSizeData from '@/components/board/mixins/PageSizeData';
import {GetProductsRestockSearchRequest, Mall, XhrErrorCode} from 'supporter';
import {DisplayEnum} from '@/types';
import { getLocalStorageMalls, getProductsConfigurationsByAllMall, toI18n } from '@/utils/commonUtils';
import ItemTable from '@/components/common/ItemTable.vue';
import RestockListDataMixin from '@/views/product/restock/RestockListDataMixin';
import cloneDeep from 'lodash/cloneDeep';


const sortType = {
  'NONE': null,
  'PRODUCT_NO_DESC': 'PRODUCT_NO_DESC',
  'RESTOCK_CNT_DESC': 'RESTOCK_CNT_DESC',
  'NOT_SEND_CNT_DESC': 'NOT_SEND_CNT_DESC'
};



type SortTypes = 'NONE' | 'PRODUCT_NO_DESC' | 'RESTOCK_CNT_DESC' | 'NOT_SEND_CNT_DESC';
interface MallUrlConfig {
  [key: string]: string;
}

@Component({
  components: {
    RestockContent,
    PageContentBottom,
    PageTitle,
    PageFormBtn,
    PageFormSelect,
    PageDateRangePicker,
    PageDateFilterBtns,
    PageSizeData,
    ItemTable
  }
})
export default class RestockList extends Mixins(RestockListDataMixin, PageSizeData) {
  @Ref('itemTable') tuiGridContainer: ItemTable;
  private displayRestockHelpFlag: boolean = false;
  private keywordTexthide: boolean = true;
  private mallNo = 0;
  private searchKeywords = '';
  private sortKeyword: SortTypes = 'NONE';
  private searchParams: GetProductsRestockSearchRequest['data'] = {
    mallNos: null,
    'keywordInfo.type': 'PRODUCT_NO',
    'keywordInfo.keywords': [],
    sort: '',
    page: 1,
    size: 30
  };
  private searchParamsResetData = cloneDeep(this.searchParams);
  private configAllMallUrl: MallUrlConfig[] = [];
  private mallInfo: Mall[] = getLocalStorageMalls();
  private get mallNos(): number[] {
    return this.mallInfo.map((mall: Mall) => mall.mallNo);
  }

  private get malls() : DisplayEnum[] {
    return [{value: '', label: toI18n(this.$t('PRODUCT_RESTOCK_OPTION_MALL_ALL'))}].concat(
      this.mallInfo.map((mall: Mall): DisplayEnum => ({value: mall.mallNo.toString(), label: mall.mallName}))
    )
  }

  get sortType() {
    return sortType[this.sortKeyword];
  }

  private created() {
    this.setConfigAllMallUrl();
    this.setDefaultSearchData();
    this.search(1, this.searchParams.size);
  }

  private async setConfigAllMallUrl(): Promise<void> {
    this.configAllMallUrl = (await getProductsConfigurationsByAllMall()).map(({mallNo, productDetailUrl}): MallUrlConfig  => ({[mallNo]: productDetailUrl}));
  }

  private setSortType() {
    this.searchParams.sort = this.sortType;
  }

  private validateCharLength(e: KeyboardEvent): void {
    const MAXCHARLENGTH = 1000;

    if (this.searchKeywords.trim().length >= MAXCHARLENGTH) {
      return alert(this.$t('PRODUCT_RESTOCK_MAX_CHAR'));
    }
  }

  private validateKeywordLength(e: KeyboardEvent): void {
    const MAXWORDLENGTH = 20;
    this.searchParams['keywordInfo.keywords'] = this.searchKeywords.trim().replace(/\r\n|\n/g, ',').split(',').filter(Boolean);

    if ((e.key !== ',') && (e.key !== 'Enter')) return;

    if (this.searchParams['keywordInfo.keywords'].length > MAXWORDLENGTH) {
      this.searchParams['keywordInfo.keywords'].pop();
      this.searchKeywords = this.searchParams['keywordInfo.keywords'].toString();
      return alert(this.$t('PRODUCT_RESTOCK_MAX_KEYWORD'));
    }
  }

  private validateType(): boolean {
    let keywords = this.searchParams['keywordInfo.keywords'] || '';

    if (!['PRODUCT_NO', 'STOCK_NO', 'OPTION_NO'].includes(this.searchParams['keywordInfo.type'])) return true;

    const isInCorrect = keywords
        .filter((v: any): boolean => v.length > 0)
        .map((el: any): void => el.trim())
        .some((v: any): boolean => /^\d+$/.test(v) === false);

    if (keywords.length && isInCorrect) {
      this.invalidKeywordSwitch = true;
      this.invalidKeywordText = this.pDI18n('PLM_YOU_CAN_ONLY_ENTER_NUMBERS_AND_COMMAS'); //숫자와 콤마만 입력할 수 있습니다
      return false;
    }

    this.invalidKeywordSwitch = false;
    return true;
  }

  private insertMallNo(): void {
    this.searchParams.mallNos = this.mallNo ? [this.mallNo] : this.mallNos;
  }

  private async search(page = 1, size?: number): Promise<any> {
    if (!this.validateType()) return;

    this.searchParams.page = page;
    if (size) {
      this.searchParams.size = size;
    }

    this.gridProps.options.pageOptions.perPage = this.searchParams.size;

    const { data } = await this.$api.getProductsRestockSearch({params: this.searchParams});


    // this.configAllMallUrl 이 setProductDetailUrl()에서 직접 가져 올 수
    // 없어서 매개 변수로 던짐
    this.gridResult = this.customResultGridData(data, this.configAllMallUrl);
  }

  // 결과 그리드에 보여질 데이터에 url 추가
  private customResultGridData = (list, urlList): any => {
    const copyList = cloneDeep(list);
    copyList.contents.forEach(mallInfo => {
      mallInfo['url'] = urlList.find(mall => mall[mallInfo.mallNo])[mallInfo.mallNo];

      if (!mallInfo.optionValue || !mallInfo.optionName || !mallInfo.productName) {
        mallInfo['_attributes'] = {
          className: { row: ['deleted-item']}
        };
      }
    });
    return copyList;
  }

  // 선택 삭제
  private async onDeleteStock(): Promise<void> {
    const checkedRows = this.tuiGridContainer.gridFunction('getCheckedRows');
    const optionNos = checkedRows.map(row => row.optionNo);

    if (!optionNos.length) {
      alert(this.$t('ORDER_MANUAL_ORDER_ALERT_24'));
      return;
    }

    const confirmResult = confirm(this.$t('PRODUCT_RESTOCK_CONFIRM_OPTION_DELETE') as string);

    if (!confirmResult) return;

    try {
      await this.$api.deleteProductsRestock({params: {optionNos}});
      this.search(1, this.searchParams.size);
    } catch (error) {
      if (!XhrErrorCode.FORBIDDEN_ERROR) {
        alert(error.data.message);
      }

    }
  }

  //초기화
  private reset(): void {
    this.searchParams = this.searchParamsResetData;
    this.searchKeywords = '';
    this.sortKeyword = 'NONE';
    this.mallNo = 0;
    this.invalidKeywordSwitch = false;
    this.setDefaultSearchData();
  }

  // 인입시 초기 검색값 설정
  private setDefaultSearchData() {
    this.searchParams.sort = this.searchParams.sort ||  'PRODUCT_NO_DESC';
    this.searchParams.mallNos = this.mallNos;
  }



}
